import { CUSTOM_INPUT_ID_PREFIX } from '../../components/fields/field.projector';
import { FieldRef } from '../types/generated/checklist-models';

const HEADER_CONTROL_ID = 'header';
const REMARKS_CONTROL_ID = 'remarks';
const COMPLETION_TIME_CONTROL_ID = 'completionTime';

export function fieldRefOf(controlId: string): FieldRef | null {
  switch (controlId) {
    case HEADER_CONTROL_ID:
      return { kind: 'Header' };
    case REMARKS_CONTROL_ID:
      return { kind: 'Remarks' };
    case COMPLETION_TIME_CONTROL_ID:
      return { kind: 'CompletionTime' };
    default:
      if (controlId.startsWith(CUSTOM_INPUT_ID_PREFIX)) {
        return {
          kind: 'CustomInput',
          customInputId: controlId.slice(CUSTOM_INPUT_ID_PREFIX.length),
        };
      }
      return null;
  }
}

export function controlIdOf(field: FieldRef): string {
  switch (field.kind) {
    case 'Header':
      return HEADER_CONTROL_ID;
    case 'Remarks':
      return REMARKS_CONTROL_ID;
    case 'CompletionTime':
      return COMPLETION_TIME_CONTROL_ID;
    case 'CustomInput':
      return `${CUSTOM_INPUT_ID_PREFIX}${field.customInputId}`;
  }
}
